import React from 'react'
import { Menu } from 'antd'
import WebMain from '../front/WebMain'
import { ShoppingOutlined, UserOutlined, KeyOutlined, LogoutOutlined, HomeOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { clearFirmLogin } from '../store/firmLoginSlice'
function FirmMain(props) {
    const dispatch = useDispatch()
    const items = [
        {
            key: 'home',
            label: '企业中心',
            icon: <HomeOutlined />,
        },
        {
            key: 'order',
            label: '订单',
            icon: <ShoppingOutlined />,
        },
        {
            key: 'user',
            label: '用户',
            icon: <UserOutlined />,
        },
        {
            key: 'password',
            label: '修改密码',
            icon: <KeyOutlined />,
        },
        {
            key: 'logout',
            label: '退出登录',
            icon: <LogoutOutlined />,
        },
    ]
    const navi = useNavigate()
    const handleMenuClick = (e) => {
        switch (e.key) {
            case 'home':
                navi('/FirmHome')
                break;
            case 'order':
                navi('/FirmOrderList')
                break;
            case 'user':
                navi('/FirmUserList')
                break;
            case 'password':
                navi('/FirmPassword')
                break;
            case 'logout':
                dispatch(clearFirmLogin())
                navi('/FirmLogin', { replace: true })
                break;
            default:
                break;
        }
    }
    return (
        <WebMain selectedKeys='firm'>
            <div style={{display:'flex',alignItems:'start'}}>
                <div style={{width:'200px',display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center',backgroundColor:'#fff',borderRight:'1px solid #e8e8e8'}}>
                    <Menu
                        items={items}
                        onClick={handleMenuClick}
                        mode="vertical"
                        style={{width:'100%',fontSize:'18px'}}
                        selectedKeys={props.leftSelectedKeys}                        
                    />
                </div>
                <div style={{flex:1,backgroundColor:'#fff',padding:'20px'}}>
                    {props.children}
                </div>
            </div>
        </WebMain>
    )
}

export default FirmMain